import React from "react";
import { Col, Row } from "react-bootstrap";
const PaymentSucessFail = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: props.parentClass },
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-center" },
                React.createElement("h1", { className: "DMSansMedium_20_500" }, props.title)),
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-center" },
                React.createElement("img", { src: props.image })),
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-center mgt-30" },
                React.createElement("p", { className: "DMSansMedium_12_500 txt_primaryGrey text-center" }, props.Message)))));
};
export default PaymentSucessFail;
